import { render, staticRenderFns } from "./ViewRecoveryCodes.vue?vue&type=template&id=7165f380&scoped=true"
import script from "./ViewRecoveryCodes.vue?vue&type=script&lang=js"
export * from "./ViewRecoveryCodes.vue?vue&type=script&lang=js"
import style1 from "./ViewRecoveryCodes.vue?vue&type=style&index=1&id=7165f380&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165f380",
  null
  
)

export default component.exports